export const VIDEOS_LIST_FETCH_IN_PROGRESS = 'VIDEOS_LIST_FETCH_IN_PROGRESS';
export const VIDEOS_LIST_FETCH_SUCCESS = 'VIDEOS_LIST_FETCH_SUCCESS';
export const VIDEOS_LIST_FETCH_ERROR = 'VIDEOS_LIST_FETCH_ERROR';
